var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMetamaskNew = function SvgMetamaskNew(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1216 3.76758L16.9619 10.5706L18.6558 6.5569L26.1216 3.76758Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97656 3.76758L14.0626 10.635L12.4516 6.5569L4.97656 3.76758Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8262 19.5352L20.3867 23.2727L25.6063 24.7087L27.1069 19.618L22.8262 19.5352Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00977 19.618L5.50108 24.7087L10.7207 23.2727L8.2812 19.5352L4.00977 19.618Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4252 13.2212L8.9707 15.4213L14.1535 15.6515L13.9694 10.082L10.4252 13.2212Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.672 13.2212L17.0818 10.0176L16.9622 15.6514L22.1357 15.4213L20.672 13.2212Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7207 23.2741L13.8322 21.7551L11.1442 19.6562L10.7207 23.2741Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2666 21.7551L20.3873 23.2741L19.9547 19.6562L17.2666 21.7551Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3876 23.2748L17.2668 21.7559L17.5154 23.7903L17.4878 24.6464L20.3876 23.2748Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7217 23.2748L13.6215 24.6464L13.6031 23.7903L13.8332 21.7559L10.7217 23.2748Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6673 18.3108L11.0713 17.5467L12.9032 16.709L13.6673 18.3108Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4326 18.3108L18.1967 16.709L20.0378 17.5467L17.4326 18.3108Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7208 23.2746L11.1626 19.5371L8.28125 19.62L10.7208 23.2746Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9456 19.5371L20.3874 23.2746L22.8269 19.62L19.9456 19.5371Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1357 15.4219L16.9622 15.652L17.4409 18.3125L18.2049 16.7107L20.046 17.5484L22.1357 15.4219Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0708 17.5484L12.912 16.7107L13.6668 18.3125L14.1547 15.652L8.97192 15.4219L11.0708 17.5484Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97168 15.4219L11.1442 19.6565L11.0706 17.5484L8.97168 15.4219Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0459 17.5484L19.9539 19.6565L22.1356 15.4219L20.0459 17.5484Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1537 15.6523L13.6658 18.3128L14.2733 21.4519L14.4114 17.3186L14.1537 15.6523Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9624 15.6523L16.7139 17.3094L16.8243 21.4519L17.4411 18.3128L16.9624 15.6523Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.441 18.3129L16.8242 21.452L17.2661 21.7558L19.9541 19.6569L20.0462 17.5488L17.441 18.3129Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0715 17.5488L11.1452 19.6569L13.8332 21.7558L14.2751 21.452L13.6675 18.3129L11.0715 17.5488Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4878 24.647L17.5155 23.7909L17.2853 23.5884H13.8148L13.6031 23.7909L13.6215 24.647L10.7217 23.2754L11.7343 24.1039L13.7872 25.5308H17.3129L19.375 24.1039L20.3876 23.2754L17.4878 24.647Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2674 21.755L16.8255 21.4512H14.2755L13.8337 21.755L13.6035 23.7894L13.8152 23.5869H17.2858L17.5159 23.7894L17.2674 21.755Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5101 11.0124L27.2926 7.25653L26.1234 3.76758L17.2676 10.3404L20.6737 13.2218L25.4882 14.6303L26.5561 13.3875L26.0958 13.0561L26.8323 12.3841L26.2615 11.9422L26.998 11.3807L26.5101 11.0124Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81836 7.25653L4.60084 11.0124L4.10374 11.3807L4.84019 11.9422L4.27864 12.3841L5.0151 13.0561L4.55481 13.3875L5.61347 14.6303L10.428 13.2218L13.8341 10.3404L4.97828 3.76758L3.81836 7.25653Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4877 14.6311L20.6731 13.2227L22.1368 15.4228L19.9551 19.6574L22.8272 19.6206H27.1079L25.4877 14.6311Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4261 13.2227L5.61155 14.6311L4.00977 19.6206H8.2812L11.1442 19.6574L8.97162 15.4228L10.4261 13.2227Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9629 15.6538L17.2667 10.3421L18.666 6.55859H12.4521L13.833 10.3421L14.1552 15.6538L14.2657 17.3292L14.2749 21.4534H16.8248L16.8432 17.3292L16.9629 15.6538Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMetamaskNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/metamask-new.26c40b61.svg";
export { ForwardRef as ReactComponent };